(function(){
  'use strict';
  angular.module("irricrops")


    .factory("selectionToolbar",[function(){
      var self = {
        visible  : false,
        text     : "",
        cancelFn : undefined,
        options: [],
        backFn : null,

        addOptions:function (array) {
          _.forEach(array, function (option) {
            //TODO validaciones
            self.options.push(option);
          });
        },
        clearOptions: function () {
          self.options = [];
        },
        setOptions:function (array) {
          self.clearOptions();
          self.addOptions(array);
        },
        hideToolbar: function () {
          self.visible = false;
        },
        showToolbar    : function (options) {
          self.visible = true;
          if(options !== undefined){
            if(options.text !== undefined){
              self.setTextToolbar(options.text);
            }
            if(options.backFn!== undefined){
              self.setBackFunction(options.backFn);
            }
            if(options.options !== undefined){
              self.setOptions(options.options);
            }
          }
        },
        setTextToolbar : function (text) {
          if(text === undefined){
            self.text = "";
          }else{
            self.text = text;
          }
        },
        setBackFunction : function (fn) {
          self.backFn = fn
        },
        back: function(){
          if(self.backFn === null || self.backFn === undefined){
            self.cancel();
          }else{
            self.backFn()
          }
        }

      }
      return self;
    }])

    //variables globales
    .factory("global", ["$timeout", "$rootScope", "CONSTANTES" ,function($timeout, $rootScope, CONSTANTES){
      var self = {
        dynamicTheme : "default",
        full: false,
        setTheme: function(theme){
          this.dynamicTheme = theme;
          this.tabApi.refreshTabs();
        },

        fullScreen : function(e){
          this.full = true;
          $timeout(function(){
            $(window).resize();
            $rootScope.$broadcast('highchartsng.reflow');
          }, 1000);
        },

        responsiveIs: function(stateParam) {
          var states = stateParam.split(' ');
          var r = false; //return
          _.forEach(states, function(state){
            if (CONSTANTES.RESPONSIVE[state] !== undefined) {
              var mediaquery = window.matchMedia("(max-width: "+CONSTANTES.RESPONSIVE[state]+"px)");
              if (mediaquery.matches) {
                r = true;
              }
            }
          });
          return r;
        },

        exitFullScreen : function(e){
          this.full = false;
          $timeout(function(){
            $(window).resize();
            $rootScope.$broadcast('highchartsng.reflow');
          }, 1000);
        },


        //las tabs activas
        tabs:[],


        //limpiar tabs activas
        clean: function(){
          self.tabs = [];
        },


        title:"", //titulo mayor de pagina


        pestana: "",
        sidebar:null,


        //test only
        setSidebar: function(sidebar){
          self.sidebar = sidebar;
        },

        //cargas globales, para vista de loading
        loads:{
          loading: false,
          stateLoad: null,
          showSpinner: function (state, name) {
            $timeout(function(){
              self.loads.loading = true;
              self.loads.stateLoad = state;
              self.loads.stateName = name;
            }, 1);
          },
          hideSpinner: function () {
            $timeout(function(){
              self.loads.loading = false;
              self.loads.stateLoad = null;
            }, 1);
          },
        },

        getSidebarData: function(vinedo_id){
          var vinedoRet = null;
          if(vinedo_id === undefined){
            vinedoRet = self.sidebar.vinas[0];
          }else{
            angular.forEach(self.sidebar.vinas, function (vina) {
              angular.forEach(vina.vinedos, function (vinedo) {
                if(vinedo.id === vinedo_id){
                  vinedoRet = vinedo;
                }
              })
            });
          }
          return vinedoRet;
        },

        getVinedo: function (nameSection, id) {
          if (self.sidebar) {
            var vinedoSelected = null;
            angular.forEach(self.sidebar.vinas, function (vina) {
              angular.forEach(vina.vinedos, function (vinedo) {
                if (vinedo.id == id && nameSection == "vinedo") {
                  vinedoSelected = vinedo;
                }
                angular.forEach(vinedo.equipos, function (equipo) {
                  if (equipo.id == id && nameSection == "equipo") {
                    vinedoSelected = vinedo;
                  }
                  angular.forEach(equipo.sectores_riego, function(cuartel) {
                    if (cuartel.id == id && nameSection == "cuartel") {
                      vinedoSelected = vinedo;
                    }
                  });
                });
              });
            });
            return vinedoSelected;
          }else{
            console.error("sidebar data is empty");
            return null;
          }
        },

        getVinaByVinedoId: function(id){
          if (self.sidebar) {
            return _.find(self.sidebar.vinas, function(vina){
              return _.find(vina.vinedos, {id: id});
            });
          }else{
            console.error("sidebar data is empty");
            return null;
          }
        },


        //obtiene las ids de los hijos en sidebar
        getChildren: function (nameParent, id) {
          if (angular.isDefined(self.sidebar)) {


            //buscar item segun nameparent e id
            // --->> vinedo
            var vinedoSelected = null,
                equipoSelected = null,
                cuartelSelected = null,
                data = {};

            angular.forEach(self.sidebar.vinas, function (vina) {
            angular.forEach(vina.vinedos, function (vinedo, ind) {
              vinedoSelected = null;
              if (vinedo.id == id && nameParent == "vinedo") {
                vinedoSelected = vinedo;
                data.vinedoIds = [vinedo.id];
              }
              angular.forEach(vinedo.equipos, function (equipo, ind2) {
                equipoSelected = null;
                if (equipo.id == id && nameParent  == "equipo") {
                  equipoSelected = equipo;
                  data.equipoIds = [equipo.id];
                }
                if(nameParent == "vinedo"){
                  if(angular.isUndefined(data.equipoIds)){
                    data.equipoIds = [];
                  }
                  data.equipoIds.push(equipo.id);
                }


                angular.forEach(equipo.sectores_riego, function(cuartel, ind3) {
                  if (cuartel.id == id && nameParent == "cuartel") {
                    cuartelSelected = cuartel;
                  }

                  if(equipoSelected !== null || vinedoSelected !== null){
                    if(angular.isUndefined(data.cuartelIds)){
                      data.cuartelIds = [];
                    }
                    data.cuartelIds.push(cuartel.id);
                  }


                });
              });
            });
            });


            return data;
          }else{
            console.error("sidebar data is empty");
            return null;
          }
        }
      };
      return self;
    }]);


})();
